import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import * as ArchiveContactsModal from 'assets/js/pages/contacts/ArchiveContactsModal';
import { useContactTypeContext } from 'assets/js/pages/contacts/ContactTypeContext';
import { ContactsViewContext } from 'assets/js/pages/contacts/ContactsViewContext';
import * as DeleteSelectedContacts from 'assets/js/pages/contacts/DeleteSelectedContacts';
import { UpdateContactNotificationsModalLocationState } from 'assets/js/pages/contacts/UpdateContactNotificationsModal';
import { UpdateTagsModalLocationState } from 'assets/js/pages/contacts/UpdateTagsModal';
import * as DropdownMenu from 'components/dropdown-menu';
import { TableContext } from 'components/table/TableContext';
import * as Tooltip from 'components/tooltip';
import { ContactType } from 'constants/contacts';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const LegacyBulkActionDropdownItems = () => {
    const contactType = useContactTypeContext();
    const { accountId } = useCurrentAccount();
    const history = useHistory();
    const { table } = useContext(TableContext);
    const selectedRows = table.getSelectedRowModel().flatRows;
    const legacySelectedContacts = selectedRows.map(row => row.original);
    const { archivedInput } = useContext(ContactsViewContext);
    const isArchived = archivedInput === 'archived';
    const resource = contactType === ContactType.Individual ? 'contacts' : 'companies';

    return (
        <>
            <DropdownMenu.Item
                onClick={() => {
                    const state: UpdateTagsModalLocationState = {
                        updateType: 'add',
                        contacts: legacySelectedContacts,
                    };
                    history.push({
                        pathname: `/accounts/${accountId}/${resource}/update-tags`,
                        state,
                    });
                }}
            >
                Add Tags
            </DropdownMenu.Item>
            <DropdownMenu.Item
                onClick={() => {
                    const state: UpdateTagsModalLocationState = {
                        updateType: 'remove',
                        contacts: legacySelectedContacts,
                    };
                    history.push({
                        pathname: `/accounts/${accountId}/${resource}/update-tags`,
                        state,
                    });
                }}
            >
                Remove Tags
            </DropdownMenu.Item>
            <DropdownMenu.Item
                onClick={() => {
                    const state: UpdateContactNotificationsModalLocationState = {
                        contacts: legacySelectedContacts,
                    };
                    history.push({
                        pathname: `/accounts/${accountId}/${resource}/update-notifications`,
                        state,
                    });
                }}
            >
                Manage Engage Subscriptions
            </DropdownMenu.Item>
            <ArchiveContactsModal.Root
                isArchived={isArchived}
                contacts={legacySelectedContacts}
                onSuccess={() => table.toggleAllRowsSelected?.(false)}
            >
                <ArchiveContactsModal.Trigger asChild>
                    <DropdownMenu.Item onSelect={e => e.preventDefault()}>
                        {isArchived ? 'Unarchive' : 'Archive'}
                    </DropdownMenu.Item>
                </ArchiveContactsModal.Trigger>
            </ArchiveContactsModal.Root>
            {selectedRows.some(({ original }) => original.cant_delete) ? (
                <Tooltip.Root>
                    <Tooltip.Trigger asChild>
                        <DropdownMenu.Item disabled onSelect={e => e.preventDefault()}>
                            Delete contacts
                        </DropdownMenu.Item>
                    </Tooltip.Trigger>
                    <Tooltip.Portal>
                        <Tooltip.Content inverse>
                            <Tooltip.Arrow inverse />
                            <p>
                                The following contacts can't be deleted:
                                <ul className="list-inside list-disc">
                                    {selectedRows
                                        .filter(item => item.original.cant_delete)
                                        .map(({ original }) => (
                                            <li key={original.id}>
                                                {contactType === ContactType.Individual ? (
                                                    <>
                                                        {original.first_name} {original.last_name}
                                                    </>
                                                ) : (
                                                    <>{original.company_name}</>
                                                )}
                                            </li>
                                        ))}
                                </ul>
                            </p>
                        </Tooltip.Content>
                    </Tooltip.Portal>
                </Tooltip.Root>
            ) : (
                <DeleteSelectedContacts.Root>
                    <DeleteSelectedContacts.Trigger asChild>
                        <DropdownMenu.Item onSelect={e => e.preventDefault()}>
                            Delete contacts
                        </DropdownMenu.Item>
                    </DeleteSelectedContacts.Trigger>
                </DeleteSelectedContacts.Root>
            )}
        </>
    );
};

export { LegacyBulkActionDropdownItems };
